module.exports = __webpack_public_path__ + "img/visa-mobile-info_x4.c4a737f2.png";